module.exports = __webpack_public_path__ + "static/img/5.180b993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/doublelift/5.png
// module id = D0j5
// module chunks = 35